<template>
  <transition name="btt-fade">
    <button v-show="visible" class="back-to-top" aria-label="Back to top" @click="toTop">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return { visible: false }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.visible = window.scrollY > 400
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
.back-to-top {
  position: fixed; right: 30px; bottom: 104px; z-index: 1500;
  width: 44px; height: 44px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  color: var(--color-gold);
  background: rgba(10, 10, 26, 0.72);
  border: 1px solid rgba(201, 168, 76, 0.45);
  backdrop-filter: blur(6px);
  transition: color 0.3s, border-color 0.3s, background 0.3s;
  &:hover {
    color: #fff;
    border-color: var(--color-gold);
    background: rgba(201, 168, 76, 0.25);
  }
}
.btt-fade-enter-active, .btt-fade-leave-active { transition: opacity 0.3s; }
.btt-fade-enter, .btt-fade-leave-to { opacity: 0; }

@media (max-width: 520px) {
  .back-to-top { right: 20px; bottom: 86px; width: 40px; height: 40px; }
}
</style>
